import content from "@plone/volto/reducers/content/content";
import { CircleList, withBlockExtensions } from "./components/";
import heroSVG from "@plone/volto/icons/hero.svg";

const applyConfig = (config) => {
  //  config.blocks.blocksConfig.listing.view = CustomListingBlockView;
  config.settings = {
    ...config.settings,
    isMultilingual: false,
    supportedLanguages: ['de', 'en'],
    defaultLanguage: 'de',
  };
  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'cirleList',
      title: 'Compass',
      template: CircleList,
    },
  ];
  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks, // Preserve other initial blocks
    ldd: [
      {
        id: 'divider0',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
      {
        id: 'block0',
        '@type': 'text',
        text: {
          blocks: [
            {
              key: 'abcde',
              text: 'Titel hinzufügen ... ',
              type: 'header-one',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
          ],
          entityMap: {},
        },
      },
      {
        id: 'block1',
        '@type': 'image',
        placeholder: 'Titelbild hinzufügen ...',
      },
      {
        id: 'divider1',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
      {
        id: 'block2',
        '@type': 'text',
        text: {
          blocks: [
            {
              key: 'abcde',
              text: 'Kurzbeschreibung und Ziele und Nutzen',
              type: 'header-one',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
          ],
          entityMap: {},
        },
      },
      {
        id: 'block3',
        '@type': 'columnsBlock',
        defaultData: {
          gridSize: 12, // Ensures proper spacing
          gridCols: [70, 30], // Moves gridCols inside defaultData
        },
      },
      {
        id: 'divider2',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
      {
        id: 'block4',
        '@type': 'image',
        placeholder: 'LDD Bild hinzufügen ...',
      },
      {
        id: 'divider3',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
      {
        id: 'block5',
        '@type': 'text',
        text: {
          blocks: [
            {
              key: 'abcde',
              text: 'Detaillierte Beschreibung',
              type: 'header-one',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
          ],
          entityMap: {},
        },
      },
      {
        id: 'block6',
        '@type': 'text',
        placeholder: 'Detaillierte Beschreibung hinzufügen ...',
      },
      {
        id: 'divider4',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
      {
        id: 'block7',
        '@type': 'text',
        text: {
          blocks: [
            {
              key: 'abcde',
              text: 'Ressourcen und Formate',
              type: 'header-one',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
          ],
          entityMap: {},
        },
      },
      {
        id: 'block8',
        '@type': 'text',
        placeholder: 'Ressourcen und Formate hinzufügen ...',
      },
      {
        id: 'divider5',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
      {
        id: 'block9',
        '@type': 'text',
        text: {
          blocks: [
            {
              key: 'abcde',
              text: 'Referenzen und Links',
              type: 'header-one',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            },
          ],
          entityMap: {},
        },
      },
      {
        id: 'block10',
        '@type': 'text',
        placeholder: 'Referenzen und Links hinzufügen ...',
      },
      {
        id: 'divider6',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
      {
        id: 'divider7',
        '@type': 'dividerBlock',
        hidden: true,
        spacing: 'l',
      },
    ],
  };

  config.blocks.requiredBlocks = [];
  return config;
};

export default applyConfig;
